import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosContainer } from './container'
import { IcosContainerDirective } from './container.directive'
import { IcosHeader, IcosAside, IcosMain, IcosFooter } from './children'
import { IcosAsideDirective, IcosFooterDirective, IcosHeaderDirective, IcosMainDirective } from './directives'


@NgModule({
  declarations: [
    IcosContainer,
    IcosHeader,
    IcosAside,
    IcosMain,
    IcosFooter,
    IcosContainerDirective,
    IcosHeaderDirective,
    IcosMainDirective,
    IcosFooterDirective,
    IcosAsideDirective,
  ],
  exports: [
    IcosContainer,
    IcosHeader,
    IcosAside,
    IcosMain,
    IcosFooter,
    IcosContainerDirective,
    IcosHeaderDirective,
    IcosMainDirective,
    IcosFooterDirective,
    IcosAsideDirective,
  ],
  imports: [CommonModule],
  entryComponents: [IcosContainer],
})
export class IcosContainerModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosContainerModule, providers: [] }
  }
}
